<template>
  <div>
    <my-head></my-head>
    <div class="newslist minH margin-auto">
      <div class="crumbs">
        首页 >
        <span style="color: #1d2129">新闻动态</span>
      </div>

      <div class="title">新闻动态</div>

      <div class="title1">最新活动和动态，洞悉行业</div>

      <div
        class="col flex-between-left"
        v-for="(item, index) in newslist"
        :key="index"
        @click="toNewsD(item.id)"
      >
        <div :style="`width: ${item.imageUrl ? '82%' : '100%'}`">
          <div class="col_title line">
            {{ item.title }}
          </div>

          <div class="col_time" v-show="item.createTime">
            {{ item.createTime | dateYMD }}
          </div>

          <div class="col_content line-two" v-html="item.content"></div>
        </div>
        <img :src="item.imageUrl" alt="" />
      </div>

      <!-- 分页 -->
      <div class="flex-center fen_ye">
        <el-pagination
          background
          :current-page.sync="nespage.page"
          :page-size="nespage.size"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
import { getRequest } from "../../api/api";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {
      //分页数据
      nespage: {
        page: 1,
        size: 10,
      },
      total: 0, //新闻总条数
      newslist: [], //新闻列表数据
    };
  },
  watch: {
    nespage: {
      handler() {
        this.newsList();
      },
      deep: true,
    },
  },
  methods: {
    // 新闻列表接口
    newsList() {
      let data = {
        page: this.nespage.page - 1,
        size: this.nespage.size,
        category: 0,
      };
      getRequest({ url: "/api/v1/markRelease/newsPage", data }).then((res) => {
        if (res.errcode == 200) {
          this.newslist = res.data;
          this.total = res.totalCount;
        }
      });
    },
    // 跳转新闻详情
    toNewsD(id) {
      this.$router.push("/nes?id=" + id);
    },
  },
  created() {
    this.newsList();
  },
};
</script>

<style lang="scss">
.newslist {
  width: 80%;
  padding-bottom: 48px;
  .fen_ye {
    margin-top: 48px;
  }
  .col {
    background: #ffffff;
    border-radius: 12px;
    padding: 16px;
    border: 1px solid #e5e6eb;
    cursor: pointer;
    margin-bottom: 24px;
    .col_time {
      font-size: 12px;
      margin-bottom: 8px;
      font-weight: 400;
      color: #86909c;
      line-height: 20px;
    }
    .col_title {
      font-size: 20px;
      margin: 0 0 8px;
      font-weight: bold;
      color: #1d2129;
      line-height: 28px;
    }
    .col_content {
      max-height: 80px;
    }
    img {
      width: 14.18%;
    }
  }
  .title1 {
    font-size: 14px;
    margin-bottom: 48px;
    font-weight: 400;
    color: #86909c;
    line-height: 22px;
  }
  .title {
    font-size: 30px;
    margin-bottom: 4px;
    font-weight: bold;
    color: #1d2129;
    line-height: 38px;
  }
}
</style>
